import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Servicios de departamentos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Service {
    public name = ''
    public price = 0
    public createdAt = new Date()
    public updatedAt = new Date()
    public unigestId = ''

    public constructor (public readonly id = 0) {}

    /**
     * Indica si la entidad es nueva y todavía no ha sido insertada en el
     * servicio
     */
    public get isNew () {
        return !this.id
    }

    /**
     * Nombre completo con nombre y precio
     */
    public get fullName () {
        return `${this.name} - ${this.price} €`
    }

    /**
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(data.id), {
            name: data.name,
            price: data.price,
            createdAt: new Date(data.created_at),
            updatedAt: new Date(data.updated_at),
            unigestId: data.unigest_id || '',
        })
    }

    /**
     * Serializa los datos para enviarlos a la API
     */
    public serialize () {
        return {
            name: this.name,
            price: this.price,
            unigest_id: this.unigestId,
        }
    }
}
